import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu"];

  connect() {
    this.addEventListeners();
  }

  disconnect() {
    this.removeEventListeners();
  }

  addEventListeners() {
    this.clickOutsideHandler = this.clickOutside.bind(this);
    document.addEventListener("click", this.clickOutsideHandler);

    this.keydownHandler = this.handleKeydown.bind(this);
    document.addEventListener("keydown", this.keydownHandler);
    
    // Add click handler to menu items
    this.handleItemClick = this.onItemClick.bind(this);
    if (this.hasMenuTarget) {
      this.menuTarget.addEventListener("click", this.handleItemClick);
    }
  }

  removeEventListeners() {
    document.removeEventListener("click", this.clickOutsideHandler);
    document.removeEventListener("keydown", this.keydownHandler);
    
    if (this.hasMenuTarget) {
      this.menuTarget.removeEventListener("click", this.handleItemClick);
    }
  }

  toggle(event) {
    event.stopPropagation();
    const menu = this.menuTarget;
    const isHidden = menu.classList.contains("hidden");
    
    if (isHidden) {
      this.show();
    } else {
      this.hide();
    }
  }

  hide() {
    if (this.hasMenuTarget) {
      this.menuTarget.classList.add("hidden");
    }
  }

  show() {
    if (this.hasMenuTarget) {
      this.menuTarget.classList.remove("hidden");
    }
  }

  onItemClick(event) {
    // Close dropdown when clicking on links or buttons
    const link = event.target.closest('a');
    const button = event.target.closest('button');
    
    if (link || button) {
      setTimeout(() => {
        this.hide();
      }, 100);
    }
  }

  clickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.hide();
    }
  }

  handleKeydown(event) {
    if (this.hasMenuTarget && !this.menuTarget.classList.contains("hidden")) {
      switch (event.key) {
        case "Escape":
          this.hide();
          break;
        case "Tab":
          if (!this.element.contains(event.target)) {
            this.hide();
          }
          break;
      }
    }
  }
}